import { render, staticRenderFns } from "./warningList.vue?vue&type=template&id=29bb47be&scoped=true&"
import script from "./warningList.vue?vue&type=script&lang=js&"
export * from "./warningList.vue?vue&type=script&lang=js&"
import style0 from "./warningList.vue?vue&type=style&index=0&id=29bb47be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bb47be",
  null
  
)

export default component.exports